import * as React from 'react';

import { cn } from '@/lib/utils';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'> & { icon?: React.ReactNode }
>(({ className, icon, ...props }, ref) => {
  return (
    <div className={cn('relative')}>
      <textarea
        data-slot="textarea"
        ref={ref}
        className={cn(
          'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-white px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          icon ? 'pl-[24px]' : null,
          className
        )}
        {...props}
      />
      <div className={cn('absolute', 'left-[6px]', 'top-[8px]', 'w-[16px]')}>
        {icon}
      </div>
    </div>
  );
});

Textarea.displayName = 'Textarea';

export { Textarea };
